import { SurveyState } from './Models/Surveys/SurveyDataModel'
import * as SurveyStateController from './StateControllers/Survey/SurveyStateController';
import * as SharedMaterialsStateController from './StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import * as MatchSurveyController from './StateControllers/Survey/MatchSurveyStateController';
import * as SurveyTemplateManagerController from './StateControllers/Survey/TemplateManagerStateController';
import * as LoginStateController from './StateControllers/LoginStateController';
import * as SharedMaterialsManagementStateController from './StateControllers/SharedMaterials/SharedMaterialsManagementStateController';
import * as SharedMaterialsPreviewStateController from './StateControllers/SharedMaterials/SharedMaterialsPreviewStateController';
import * as BulkReportStateController from './StateControllers/BulkReport/BulkReportStateController';
import { AppServices } from '../AppServices';
import * as EngagementStateController from './StateControllers/Engagement/EngagementStateController';
import * as XmlExportStateController from './StateControllers/XmlExport/XmlExportStateController';
import * as StartStateController from './StateControllers/Start/StartStateController';
import * as InviteSuppliersStateController from './StateControllers/Supplier/InviteSuppliersStateController';
import * as CustomersStateController from './StateControllers/Customers/CustomersStateController';
import * as SurveyResponseController from './StateControllers/Survey/SurveyResponse/SurveyResponseController';
import * as AISurveyAgentController from './StateControllers/Survey/SurveyResponse/AISurveyAgentController';
import { SurveyMatchData } from './Models/Surveys/SurveyMatchDataModel';
import { Ipc1752AExportState } from './Models/XmlExport/XmlExportDataModel';
import { TaskManagementState } from './Models/TaskManagement/TaskManagementDataModel';
import * as TaskManagementStateController from "./StateControllers/TaskManagement/TaskManagementStateController";
import * as SelectSuppliersMaterialsTableStateController from './StateControllers/Supplier/SelectSuppliersMaterialsTableStateController';
import { SurveyResponseState } from './StateControllers/Survey/SurveyResponse/SurveyResponseStates';

// The top-level state object
export interface ApplicationState {
    appServices: AppServices | null | undefined;
    sharedMaterialsState: SharedMaterialsStateController.SharedMaterialsState | undefined;
    createAndEditSurveysState: SurveyState | undefined;
    sharedMaterialsManagementState: SharedMaterialsManagementStateController.ManagementState | undefined;
    sharedMaterialsPreviewState: SharedMaterialsPreviewStateController.SharedMaterialPreviewState | undefined;
    surveyMatchState: SurveyMatchData | undefined;
    bulkReportState: BulkReportStateController.BulkReportState | undefined;
    engageState: EngagementStateController.EngagementState | undefined;
    ipc1752aExportState: Ipc1752AExportState | undefined;
    startState: StartStateController.StartState | undefined;
    inviteSuppliersState: InviteSuppliersStateController.InviteSuppliersState | undefined;
    taskManagementState: TaskManagementState | undefined;
    myCustomersState: CustomersStateController.MyCustomersState | undefined;
    surveyTemplateManagerState: SurveyTemplateManagerController.SurveyTemplateManagerData | undefined;
    selectSuppliersMaterialsTableState: SelectSuppliersMaterialsTableStateController.SelectSuppliersMaterialsTableState | undefined;
    surveyResponseState: SurveyResponseState | undefined;
    aiSurveyAgentState: AISurveyAgentController.AISurveyAgentState | undefined;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the NAMES MATCH EXACTLY, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    appServices: LoginStateController.reducer,
    sharedMaterialsState: SharedMaterialsStateController.reducer,
    createAndEditSurveysState: SurveyStateController.reducer,
    sharedMaterialsManagementState: SharedMaterialsManagementStateController.reducer,
    sharedMaterialsPreviewState: SharedMaterialsPreviewStateController.reducer,
    surveyMatchState: MatchSurveyController.reducer,
    bulkReportState: BulkReportStateController.reducer,
    engageState: EngagementStateController.reducer,
    ipc1752aExportState: XmlExportStateController.reducer,
    startState: StartStateController.reducer,
    inviteSuppliersState: InviteSuppliersStateController.reducer,
    taskManagementState: TaskManagementStateController.reducer,
    myCustomersState: CustomersStateController.reducer,
    surveyTemplateManagerState: SurveyTemplateManagerController.reducer,
    selectSuppliersMaterialsTableState: SelectSuppliersMaterialsTableStateController.reducer,
    surveyResponseState: SurveyResponseController.reducer,
    aiSurveyAgentState: AISurveyAgentController.reducer
};

// These types can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.

export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

export interface AppThunkActionAsync<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): Promise<void>;
}
